export default {"src":"/pro/_next/static/media/avax.3384c338.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};